import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentDetailPageContext,
  ComponentDetailPageInitialState,
} from "./";

export const ComponentDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ComponentDetailPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentDetailPageContext.Provider value={context}>
      {children}
    </ComponentDetailPageContext.Provider>
  );
};
